import { lazy,Route } from '@tanstack/router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const CasinoRegister = lazy(() => import('../pages/casino-register'))

export const casinoRegisterRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/casino-register',
  component: CasinoRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
